import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const eventDetailsStyles = makeStyles((theme: Theme) =>
    createStyles({
        content: {
            flexGrow: 1,
            marginTop: "120px",
            marginLeft: "50px",
        },
        margin: {
            marginBottom: "60px",
            marginTop: "40px",
        },
        title: {
            color: "#181818",
            fontWeight: 500,
            fontSize: "32px",
            marginBottom: "12px",
        },
        text: {
            color: "#000000",
        },
        gridContainer: {
            marginTop: "25px",
            marginLeft: "50px",
        },
        indicatorContainer: {
            height: "80vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
        backBtn: {
            padding: "0px",
            minWidth: "none",
            marginTop: "-60px",
            marginLeft: "-5px",
            "&:hover": {
                backgroundColor: "inherit",
            },
        },
        backText: {
            color: "#999999",
            fontWeight: 500,
            marginLeft: "3px",
            fontSize: "18px",
        },

        dis: {
            position: "fixed",
            width: "100%",
            height: "100vh",
            backgroundColor: "rgba(82, 82, 82, 0.6)",
            zIndex: theme.zIndex.appBar + 400,
        },
    })
);
